import React from 'react';
import { Trash2, RefreshCw, Download } from 'lucide-react';
import { apiCall, useAdminData } from './_helpers';

const SubscribersManager = ({ onMessage }) => {
  const [subs, setSubs, refetch] = useAdminData('newsletter-subscribers');

  const remove = async (id) => {
    if (!window.confirm('Delete this subscriber?')) return;
    try { await apiCall('DELETE', `newsletter-subscribers/${id}`); onMessage('success', 'Deleted'); refetch(); }
    catch (e) { onMessage('error', e.message); }
  };

  const exportCSV = () => {
    const rows = [['Email', 'Name', 'Source', 'Subscribed At']];
    subs.forEach((s) => rows.push([s.email, s.name || '', s.source || '', s.subscribed_at || '']));
    const csv = rows.map((r) => r.map((c) => `"${String(c).replace(/"/g, '""')}"`).join(',')).join('\n');
    const blob = new Blob([csv], { type: 'text/csv' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url; a.download = 'newsletter_subscribers.csv'; a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-2xl font-bold">Newsletter Subscribers ({subs.length})</h2>
        <div className="flex gap-2">
          <button onClick={refetch} className="bg-gray-100 hover:bg-gray-200 px-4 py-2 rounded-lg flex items-center gap-2"><RefreshCw size={16} /> Refresh</button>
          <button onClick={exportCSV} disabled={subs.length === 0} className="bg-[#C9A86C] text-white px-4 py-2 rounded-lg flex items-center gap-2 hover:bg-[#B8956A] disabled:opacity-50"><Download size={16} /> Export CSV</button>
        </div>
      </div>
      <div className="bg-white rounded-xl shadow-md overflow-hidden">
        <table className="w-full">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-6 py-3 text-left text-sm font-semibold">Email</th>
              <th className="px-6 py-3 text-left text-sm font-semibold">Name</th>
              <th className="px-6 py-3 text-left text-sm font-semibold">Source</th>
              <th className="px-6 py-3 text-left text-sm font-semibold">Subscribed</th>
              <th className="px-6 py-3 text-left text-sm font-semibold">Actions</th>
            </tr>
          </thead>
          <tbody>
            {subs.map((s) => (
              <tr key={s._id} className="border-t">
                <td className="px-6 py-4">{s.email}</td>
                <td className="px-6 py-4">{s.name || '—'}</td>
                <td className="px-6 py-4">{s.source || '—'}</td>
                <td className="px-6 py-4 text-sm text-gray-600">{s.subscribed_at ? new Date(s.subscribed_at).toLocaleString() : '—'}</td>
                <td className="px-6 py-4"><button onClick={() => remove(s._id)} className="text-red-600 hover:bg-red-50 p-2 rounded"><Trash2 size={18} /></button></td>
              </tr>
            ))}
            {subs.length === 0 && <tr><td colSpan={5} className="px-6 py-12 text-center text-gray-500">No subscribers yet.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default SubscribersManager;
